import dayjs from 'dayjs';

/**
 * UTC の ISO 日時文字列（例: "2024-01-15T06:30:00.000+0000"）を
 * JST の日付文字列 "YYYY-MM-DD" に変換して返す。
 * 'T' を含まない文字列（既に日付形式）はそのまま返す。
 * 空文字列・falsy は空文字列を返す。
 */
export function isoUtcToJstDate(dateStr: string): string {
  if (!dateStr || !dateStr.includes('T')) return dateStr || '';
  try {
    return dayjs(dateStr).add(9, 'hour').format('YYYY-MM-DD');
  } catch {
    return dateStr.split('T')[0];
  }
}

/**
 * 指定した日付が今日より未来かどうかを返す。
 * @param date dayjs オブジェクト・日付文字列 (YYYY-MM-DD)・null/undefined のいずれか
 */
export function isFutureDate(date: dayjs.Dayjs | string | null | undefined): boolean {
  if (!date) return false;
  return dayjs(date).startOf('day').isAfter(dayjs().startOf('day'));
}

/**
 * 指定した日付が今日より過去かどうかを返す（今日は false）。
 * @param date dayjs オブジェクト・日付文字列 (YYYY-MM-DD)・null/undefined のいずれか
 */
export function isPastDate(date: dayjs.Dayjs | string | null | undefined): boolean {
  if (!date) return false;
  return dayjs(date).startOf('day').isBefore(dayjs().startOf('day'));
}
